<template>
    <div class="wrapper">
        <slot/>
    </div>
</template>

